import GenericService from './genericService';
import axiosInstance from '../utils/axios';

class CompanyService extends GenericService {
  constructor() {
    super('/posting_groups', axiosInstance);
  }
}

export default new CompanyService(); 